import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';
import outfitFont from '@/assets/fonts/Outfit-VariableFont_wght.ttf';

Font.register({
  family: 'Outfit',
  src: outfitFont,
  fontWeight: 'normal',
});
const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 11,
    fontFamily: 'Outfit',
    backgroundColor: '#ffffff',
  },
  header: {
    marginBottom: 16,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#0f0f0f',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#050505',
    fontFamily: 'Outfit',
  },
  subTitle: {
    fontSize: 12,
    textAlign: 'left',
    color: '#111111',
    marginTop: 9,
    fontFamily: 'Outfit',
  },
  tableHeader: {
    flexDirection: 'row',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#0f0f0f',
    backgroundColor: '#d8d8d8',
    fontFamily: 'Outfit',
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 6,
    borderBottomWidth: 0.5,
    borderBottomColor: '#2a2a2a',
  },
  tableRowAlt: {
    backgroundColor: '#e6e6e6',
  },
  cell: {
    flex: 1,
    fontSize: 10,
    color: '#050505',
    fontFamily: 'Outfit',
  },
  footer: {
    marginTop: 12,
    fontSize: 11,
    textAlign: 'right',
    color: '#111111',
    fontFamily: 'Outfit',
  },
});


function convertHoursToHHMMSS(decimalHours: number): string {
  const totalSeconds = Math.floor(decimalHours * 3600);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}


export const MonthlyReportPDF = ({
  reportData,
  totalHours,
  year,
  month,
  userName,
}: {
  reportData: any[];
  totalHours: number;
  year: number;
  month: number;
  userName: string;
}) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>
            Reporte Mensual de Asistencia –{' '}
            {new Date(year, month - 1).toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric',
            })}
          </Text>
          <Text style={styles.subTitle}>Colaborador: {userName}</Text>
        </View>

        <View style={styles.tableHeader}>
          <Text style={styles.cell}>#</Text>
          <Text style={styles.cell}>Fecha</Text>
          <Text style={styles.cell}>Hora inicio</Text>
          <Text style={styles.cell}>Hora final</Text>
          <Text style={styles.cell}>Horas (h)</Text>
          <Text style={styles.cell}>Horas (hh:mm:ss)</Text>
        </View>

        {reportData.map((session, idx) => (
          <View
            key={session.$id}
            style={[
              styles.tableRow,
              idx % 2 === 1 ? styles.tableRowAlt : {},
            ]}
          >
            <Text style={styles.cell}>{idx + 1}</Text>
            <Text style={styles.cell}>
              {new Date(session.clockIn).toLocaleDateString('es-ES')}
            </Text>
            <Text style={styles.cell}>
              {new Date(session.clockIn).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </Text>
            <Text style={styles.cell}>
              {session.clockOut
                ? new Date(session.clockOut).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })
                : 'S/H'}
            </Text>
            <Text style={styles.cell}>
              {session.totalWorkTime.toFixed(2)}
            </Text>
            <Text style={styles.cell}>
              {convertHoursToHHMMSS(session.totalWorkTime)}
            </Text>
          </View>
        ))}
        <Text style={styles.footer}>
          Total horas del mes: {totalHours.toFixed(2)}
        </Text>
        <Text style={styles.footer}>
          (Equivale a {Math.floor(totalHours)} horas{' '}
          {Math.floor((totalHours * 60) % 60)} minutos{' '}
          y {Math.round((totalHours * 3600) % 60)} segundos)
        </Text>

      </Page>
    </Document>
  );
};
<Document>
  <View>
  </View>
</Document>

